import { useState } from 'react';
import CreateMIModel from './CreateMIModel';
import RegisterThirdParty from './RegisterThirdParty';

export default function CreateModel() {
  const [activeTab, setActiveTab] = useState('mi'); // 'mi' or 'third-party'

  return (
    <div className="max-w-3xl mx-auto px-4 py-8">
      <header className="mb-8">
        <h1 className="text-2xl md:text-3xl font-bold text-ktx-purple">
          Create New Model
        </h1>
        <p className="mt-2 text-gray-600">
          Choose the type of model you want to create or register
        </p>
      </header>

      {/* Tab Navigation */}
      <div className="mb-6 border-b border-gray-200">
        <nav className="flex -mb-px" aria-label="Tabs">
          <button
            onClick={() => setActiveTab('mi')}
            className={`py-4 px-1 border-b-2 font-medium text-sm mr-8 ${
              activeTab === 'mi'
                ? 'border-ktx-purple text-ktx-purple'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            }`}
            aria-current={activeTab === 'mi' ? 'page' : undefined}
          >
            MI Model
          </button>
          <button
            onClick={() => setActiveTab('third-party')}
            className={`py-4 px-1 border-b-2 font-medium text-sm ${
              activeTab === 'third-party'
                ? 'border-ktx-purple text-ktx-purple'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            }`}
            aria-current={activeTab === 'third-party' ? 'page' : undefined}
          >
            Third-Party Model
          </button>
        </nav>
      </div>

      {/* Tab Content */}
      <div className="tab-content">
        {activeTab === 'mi' ? (
          <div className="mi-model-tab">
            <CreateMIModel />
          </div>
        ) : (
          <div className="third-party-model-tab">
            <RegisterThirdParty />
          </div>
        )}
      </div>
    </div>
  );
}